import React from "react";
import { useComponentDidMount } from "../../../lib/hook";
import { connect } from "react-redux";
import {
  EpisodesByShowActionManager,
  ShowFetchActionManager,
} from "../../../action_managers/shows";
import ShowDetailsEpisodeList from "./show_details_episode_list";
import { withRouter } from "react-router";
import ShowPageWrapper from "./show_page_wrapper";
import { Link } from "react-router-dom";

const ShowEpisodesPage = props => {
  const showUUID = props.match.params.showUUID;
  useComponentDidMount(() => {
    if (!props.shows[showUUID]) {
      props.fetchShowByUUID(showUUID);
    }
  }, []);
  const show = props.shows[showUUID];
  return (
    <ShowPageWrapper
      show={show}
      title={"Episodes"}
      rightLink={() => (
        <Link data-cy="new-episode" to={"/shows/" + showUUID + "/ep/create"} className={"bold"}>
          New Episode
        </Link>
      )}>
      <ShowDetailsEpisodeList
        fetchEpisodesForShow={props.fetchEpisodesForShow}
        showUUID={showUUID}
        user={props.user}
        episodeInfo={props.episodesByShow[showUUID]}
        historyPush={props.history.push}
      />
    </ShowPageWrapper>
  );
};

export default withRouter(
  connect(
    state => ({
      shows: state.shows.shows,
      episodesByShow: state.episodesByShow,
      user: state.user.user,
    }),
    {
      fetchEpisodesForShow: (showUUID, user) =>
        new EpisodesByShowActionManager({ showUUID, user }).run(),
      fetchShowByUUID: showUUID => new ShowFetchActionManager({ showUUID }).run(),
    }
  )(ShowEpisodesPage)
);
